/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPersonRequest
 */
export interface GetPersonRequest {
    /**
     * 
     * @type {string}
     * @memberof GetPersonRequest
     */
    personId: string;
}

export function GetPersonRequestFromJSON(json: any): GetPersonRequest {
    return GetPersonRequestFromJSONTyped(json, false);
}

export function GetPersonRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPersonRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'personId': json['person_id'],
    };
}

export function GetPersonRequestToJSON(value?: GetPersonRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'person_id': value.personId,
    };
}


